import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase environment variables are required');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 型定義
export interface Profile {
  id: string;
  user_id: string;
  email: string;
  name: string;
  avatar_url?: string;
  phone?: string;
  created_at: string;
  updated_at: string;
}

export interface UserRole {
  type: 'system' | 'agency' | 'tenant';
  role: string;
  agency_id?: string;
  agency?: any;
  tenant_id?: string;
  tenant?: any;
  permissions?: Record<string, any>;
  is_active: boolean;
}

export interface AdminInfo {
  role: string;
  permissions?: Record<string, any>;
  is_active: boolean;
}

export interface CurrentUser {
  id: string;
  email?: string;
  full_name?: string;
  avatar_url?: string;
  is_system_admin: boolean;
  is_super_admin: boolean;
  permissions: string[];
  accessible_tenant_ids?: string[];
  admin_info?: AdminInfo;
  // 以下は互換性のために残す
  profile?: Profile;
  roles?: UserRole[];
  is_agency_user?: boolean;
  is_tenant_user?: boolean;
}

export interface AuthError {
  message: string;
  status?: number;
}